export default "__VITE_ASSET__CfifcZ97__"